<div class="bary-table-list table-responsive">
  <table mdbTable [hover]="true" [small]="true">
    <thead>
      <tr jhiSort [(predicate)]="pagination.predicate" [(ascending)]="pagination.reverse" (sortChange)="transition()">
        <th jhiSortBy="pickupCountry">
          <span jhiTranslate="cutoff.pickupCountry">Pickup Country</span>
          <fa-icon icon="sort"></fa-icon>
        </th>
        <th jhiSortBy="pickupZipCodeData">
          <span jhiTranslate="cutoff.pickupZipCodeData">Pickup Zip Code</span>
          <fa-icon icon="sort"></fa-icon>
        </th>
        <th jhiSortBy="pickupCutoff">
          <span jhiTranslate="cutoff.pickupCutoff">Pickup Cut Off</span>
        </th>
        <th jhiSortBy="pickupCutoffDay">
          <span jhiTranslate="cutoff.pickupCutoffDay">Pickup Cut Off Day</span>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let cutoff of cutOffs; trackBy: trackId">
        <td>
          <span>{{ cutoff.pickupCountry }}</span>
        </td>
        <td>
          <span>{{ cutoff.pickupZipCodeData }}</span>
        </td>
        <td>
          <span>{{ cutoff.pickupCutOff }}</span>
        </td>
        <td>
          <span>{{ cutoff.pickupCutOffDay }}</span>
        </td>
      </tr>
      <tr [hidden]="cutOffs && cutOffs.length > 0">
        <td colspan="5" class="table-data-not-found">
          <div class="text-center">
            <p class="lead p-5" jhiTranslate="cutoff.home.notFound">No cutoff</p>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>
